/**
 * An AbortSignal that fires after `ms`.
 *
 * AbortSignal.timeout() arrived in Chrome 103. Android's WebView is updated
 * separately from the app, and a phone that has not updated it would throw on
 * every request — which the app would read as "no signal", forever.
 */
export function timeoutSignal(ms: number): AbortSignal {
  if (typeof AbortSignal.timeout === 'function') return AbortSignal.timeout(ms);
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller.signal;
}
